
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import CrossDisciplinaryManager from './CrossDisciplinaryManager';
import ThematicTrailsManager from './ThematicTrailsManager';
import EnhancedTaxonomyManager from './EnhancedTaxonomyManager';
import { Network, Route, Trees } from 'lucide-react';

const Phase2Manager: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold mb-2">Cross-Disciplinary & Structural Management</h1>
        <p className="text-black">
          Advanced tools for managing knowledge relationships, learning paths, and taxonomy structure
        </p>
      </div>

      <Tabs defaultValue="cross-disciplinary" className="space-y-6">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="cross-disciplinary" className="flex items-center gap-2">
            <Network className="h-4 w-4" />
            Cross-Disciplinary
          </TabsTrigger>
          <TabsTrigger value="thematic-trails" className="flex items-center gap-2">
            <Route className="h-4 w-4" />
            Thematic Trails
          </TabsTrigger>
          <TabsTrigger value="taxonomy" className="flex items-center gap-2">
            <Trees className="h-4 w-4" />
            Taxonomy
          </TabsTrigger>
        </TabsList>

        <TabsContent value="cross-disciplinary">
          <CrossDisciplinaryManager />
        </TabsContent>

        <TabsContent value="thematic-trails">
          <ThematicTrailsManager />
        </TabsContent>

        <TabsContent value="taxonomy">
          <EnhancedTaxonomyManager />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Phase2Manager;

